module.exports = __webpack_public_path__ + "static/media/EK.2af6f382.png";